import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { HubApiService } from '@shared/common/host/data/service/hub.api-service';
import { HostDependencyTypes } from '@shared/common/host/host.dependency-types';
import { MessagingApiService } from '@shared/common/host/data/service/messaging.api-service';
import { CockpitApiService } from '@shared/common/host/data/service/cockpit.api-service';
import { CockpitJwtRefreshGateway } from '@shared/common/host/data/service/cockpit-jwt-refresh.gateway';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import type { JwtRefreshGateway } from '@shared/common/network/domain/service/jwt-refresh.gateway';

export const hostContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options.bind<CockpitApiService>(HostDependencyTypes.CockpitApiService).to(CockpitApiService).inSingletonScope();
  options.bind<HubApiService>(HostDependencyTypes.HubApiService).to(HubApiService).inSingletonScope();
  options.bind<MessagingApiService>(HostDependencyTypes.MessagingApiService).to(MessagingApiService).inSingletonScope();
  options
    .bind<JwtRefreshGateway>(NetworkDependencyTypes.JwtRefreshGateway)
    .to(CockpitJwtRefreshGateway)
    .inSingletonScope();
});
